import {useRef, useEffect} from 'react';

export const useUpdateEffect = (
	effect: Function,
	dependencies?: React.DependencyList,
) => {
	const isInitialMount = useRef(true);
	const effectRef = useRef(effect);
	useEffect(() => {
		effectRef.current = effect;
	});

	useEffect(() => {
		if (isInitialMount.current) {
			isInitialMount.current = false;
			return;
		}
		return effectRef.current();
	}, dependencies);
};

export default useUpdateEffect;
